export default __webpack_public_path__ + "static/media/logo.cd001ee4.svg";